import React, { useState } from "react"
import PropTypes from "prop-types"

import wait from "@helpers/wait"
import Drawer from "@components/Page/Drawer"
import { useInvestmentStore } from "@stores/backstage"
import { W0, HEADER_HEIGHT, DRAWER_WIDTH3 } from "@components/constants"

import Title from "./Title"
import Investment from "./Investment"


const InvestmentDrawer = ({ drawer, onClose }) => {
  const [ investmentId, setInvestmentId ] = useState()

  const {
    useInvestment,
    readInvestment,
    updateInvestment
  } = useInvestmentStore()

  const investment = useInvestment(investmentId)

  const onOpen = id =>
    setInvestmentId(id)

  const onDrawerClose = () => {
    wait(300).then(() => setInvestmentId())
    onClose()
  }

  const styles = {
    body: { paddingTop: W0 },
    header: { minHeight: HEADER_HEIGHT + 1 }
  }

  const title = (
    <Title
      name={investment?.name}
      investmentId={investmentId}
    />
  )

  const drawerProps = {
    width: DRAWER_WIDTH3,
    onClose: onDrawerClose,
    title,
    drawer,
    onOpen,
    styles,
  }

  return (
    <Drawer {...drawerProps}>
      {
        investment && (
          <Investment
            investment={investment}
            readInvestment={readInvestment}
            updateInvestment={updateInvestment}
          />
        )
      }
    </Drawer>
  )
}

InvestmentDrawer.propTypes = {
  drawer: PropTypes.shape({}).isRequired,
  onClose: PropTypes.func,
}

InvestmentDrawer.defaultProps = {
  onClose: () => {},
}

export default InvestmentDrawer
